<template>
  <div class="p-8">
    <div class="max-w-7xl mx-auto">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex-1 min-w-0">
          <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            Email Campaigns
          </h2>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4 space-x-2">
          <CreateNewEmailCampaignAction
            v-if="$membershipHasPermissionTo('create email campaigns')"
            :account-id="accountId"
            :project-id="projectId"
            @created="$emit('created')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreateNewEmailCampaignAction from './CreateNewEmailCampaignAction.vue';

export default {
  components: {
    CreateNewEmailCampaignAction,
  },
  props: {
    accountId: {
      type: String,
      default: null,
    },
    projectId: {
      type: String,
      default: null,
    },
  },
};
</script>
